import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";

import { PercentageValue } from "../../../percentage_value";

type MatchCellProps = {
  shortlist: ShortlistWithScores;
};

export const MatchCell = ({ shortlist }: MatchCellProps) => (
  <PercentageValue value={shortlist.scores?.normalizedScore} />
);
